import IconButton from '@material-ui/core/IconButton';
import classNames from 'classnames';
import React from 'react';
import { BackArrowIcon } from 'components/Icons';
import { Color } from 'utils/color';
import style from './BackIconButton.scss';

type Props = {
  containerClassName?: string;
  onClick: () => void;
  hasBorder?: boolean;
};

export const BackIconButton: React.FC<Props> = ({ onClick, containerClassName, hasBorder = false }) => {
  return (
    <IconButton className={classNames(style.button, hasBorder && style.border, containerClassName)} onClick={onClick}>
      <BackArrowIcon color={Color.DARK_BLUE_NEW} width={24} height={24} />
    </IconButton>
  );
};
